import {
  AdminPasswordResetRequest,
  CognitoUser,
  Credential,
  PasswordResetRequest,
  PasswordResetTokenStatus,
} from '@cco/model';
import { createAction, props, union } from '@ngrx/store';
import { DateTime } from 'luxon';

export enum AuthActionTypes {}

export const AdminPasswordReset = createAction(
  '[Auth] Admin Password Reset',
  props<{ userId: number; adminPasswordResetRequest: AdminPasswordResetRequest }>(),
);
export const AdminPasswordResetSuccess = createAction('[Auth] Admin Password Reset Success');
export const AdminPasswordResetFailure = createAction(
  '[Auth] Admin Password Reset Failure',
  props<{ error: any }>(),
);
export const ClearUsernameByResetToken = createAction('[Auth] CLEAR_USERNAME_BY_RESET_TOKEN');
export const GetPasswordResetTokenStatus = createAction(
  '[Auth] GET_PASSWORD_RESET_TOKEN_STATUS',
  props<{ passwordResetToken: string }>(),
);
export const GetPasswordResetTokenStatusSuccess = createAction(
  '[Auth] GET_PASSWORD_RESET_TOKEN_STATUS_SUCCESS',
  props<{ status: PasswordResetTokenStatus }>(),
);
export const GetPasswordResetTokenStatusFailure = createAction(
  '[Auth] GET_PASSWORD_RESET_TOKEN_STATUS_FAILURE',
  props<{ error: any }>(),
);
export const Login = createAction('[Auth] Login', props<{ credential: Credential }>());
export const LoginSuccess = createAction('[Auth] Login Success', props<{ user: CognitoUser }>());
export const LoginFailure = createAction('[Auth] Login Failure', props<{ error: any }>());
export const LoginPing = createAction('[Auth] Login Ping');
export const LoginPingSuccess = createAction(
  '[Auth] Login Ping Success',
  props<{ user: CognitoUser }>(),
);
export const LoginRedirect = createAction(
  '[Auth] Login Redirect',
  props<{ postLoginRedirectUrl: string }>(),
);
export const Logout = createAction('[Auth] Logout');
export const LogoutSuccess = createAction('[Auth] Logout Success');
export const LogoutError = createAction('[Auth] Logout Error', props<{ error: any }>());
export const ResetPassword = createAction(
  '[Auth] Reset Password',
  props<{ passwordResetRequest: PasswordResetRequest }>(),
);
export const ResetPasswordSuccess = createAction(
  '[Auth] Reset Password Success',
  props<{ token: string }>(),
);
export const ResetPasswordFailure = createAction(
  '[Auth] Reset Password Failure',
  props<{ error: any }>(),
);
export const XsrfPing = createAction('[Auth] XSRF Ping', props<{ requestTime: DateTime }>());
export const XsrfPingSuccess = createAction('[Auth] XSRF Ping Success', props<{ rtt: number }>());
export const XsrfPingFailure = createAction('[Auth] XSRF Ping Failure', props<{ error: any }>());

export const AuthActions = union({
  AdminPasswordReset,
  AdminPasswordResetSuccess,
  AdminPasswordResetFailure,
  ClearUsernameByResetToken,
  GetPasswordResetTokenStatus,
  GetPasswordResetTokenStatusSuccess,
  GetPasswordResetTokenStatusFailure,
  Login,
  LoginSuccess,
  LoginFailure,
  LoginPing,
  LoginPingSuccess,
  LoginRedirect,
  Logout,
  LogoutSuccess,
  LogoutError,
  ResetPassword,
  ResetPasswordSuccess,
  ResetPasswordFailure,
  XsrfPing,
  XsrfPingSuccess,
  XsrfPingFailure,
});
